import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext.jsx';
import api from '../services/api.js';
import { applyBranding } from '../utils/branding.js';

/**
 * Applies the clinic's branding across the platform. When a user is
 * authenticated it loads the clinic settings and sets the brand colours as CSS
 * custom properties on :root, so an admin's branding changes are reflected
 * app-wide. Renders nothing.
 */
export default function BrandingApplier() {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    let alive = true;
    api
      .getClinicSettings()
      .then((s) => {
        if (alive) applyBranding(s);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [isAuthenticated]);

  return null;
}
